import { render, staticRenderFns } from "./InternationalShipments.vue?vue&type=template&id=cb14005e&scoped=true"
import script from "./InternationalShipments.vue?vue&type=script&lang=js"
export * from "./InternationalShipments.vue?vue&type=script&lang=js"
import style0 from "./InternationalShipments.vue?vue&type=style&index=0&id=cb14005e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb14005e",
  null
  
)

export default component.exports